import { useState, useEffect } from 'react';

export const useEffectWithPause = ({ enablePause }: { enablePause: boolean }) => {
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (enablePause) setIsPaused(true);
  }, [enablePause]);

  useEffect(() => {
    if (isPaused) setIsPaused(false);
  }, [isPaused]);

  const usePausedEffect: typeof useEffect = (effect, deps) => {
    useEffect(() => {
      if (isPaused) return;
      return effect();
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
  };

  return {
    usePausedEffect,
  };
};
